export const Type: { [key: number]: string } = {
    0: 'Уплата налога',
    1: 'Пени, штрафы',
    2: 'Комиссия за эквайринг',
    3: 'Обслуживание серверов GTM',
    4: 'Обслуживание платформы',
    5: 'Иное'
}